import { withDependencies, named } from '@wix/thunderbolt-ioc'
import {
	contextIdSymbol,
	FeatureStateSymbol,
	ILogger,
	IPageDidMountHandler,
	LoggerSymbol,
	PageFeatureConfigSymbol,
} from '@wix/thunderbolt-symbols'
import { IFeatureState } from 'thunderbolt-feature-state'
import { ExternalComponentLoaderSymbol, name } from './symbols'
import type {
	ExternalComponentPageConfig,
	ExternalComponentSecondPhaseRenderComponentIds,
	IExternalComponentLoader,
	IExternalComponentProps,
} from './types'
import { ComponentsStore, ComponentsStoreSymbol, ViewerComponent } from 'feature-components'

export const ExternalComponentPageDidMount = withDependencies(
	[
		ComponentsStoreSymbol,
		named(PageFeatureConfigSymbol, name),
		ExternalComponentLoaderSymbol,
		LoggerSymbol,
		contextIdSymbol,
		named(FeatureStateSymbol, name),
	],
	(
		componentsStore: ComponentsStore,
		pageConfig: ExternalComponentPageConfig,
		externalComponentLoader: IExternalComponentLoader,
		logger: ILogger,
		contextId: string,
		featureState: IFeatureState<ExternalComponentSecondPhaseRenderComponentIds>
	): IPageDidMountHandler => {
		return {
			pageDidMount: async () => {
				const secondPhaseRenderComponentIds = featureState.get().failedInSsr
				if (!secondPhaseRenderComponentIds) {
					return
				}

				for (const compId in secondPhaseRenderComponentIds) {
					const comp = componentsStore.get<ViewerComponent>(
						compId
					) as ViewerComponent<IExternalComponentProps>
					const compData = pageConfig.externalComponents[compId]

					externalComponentLoader.loadComponentAndUpdateProps({ comp, compData, contextId, isRetry: true })
				}

				featureState.update((state) => ({ ...state, failedInSsr: null }))
			},
		}
	}
)
